/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrdersPaginatedDto as DigiworkMaitreDPosDtoOrderV2GetOrdersPaginatedDto } from '../../models/Digiwork/MaitreD/Pos/DTO/OrderV2/get-orders-paginated-dto';
import { PaginatedOrderDtOs as DigiworkMaitreDPosDtoOrderV2PaginatedOrderDtOs } from '../../models/Digiwork/MaitreD/Pos/DTO/OrderV2/paginated-order-dt-os';

export interface GetFilteredOrdersPaginated$Params {
      body?: DigiworkMaitreDPosDtoOrderV2GetOrdersPaginatedDto
}

export function getFilteredOrdersPaginated(http: HttpClient, rootUrl: string, params?: GetFilteredOrdersPaginated$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2PaginatedOrderDtOs>> {
  const rb = new RequestBuilder(rootUrl, getFilteredOrdersPaginated.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2PaginatedOrderDtOs>;
    })
  );
}

getFilteredOrdersPaginated.PATH = '/api/orders/get-orders-paginated';
